import { buildClinicPortalUrl } from "./portalHost";

export function getClinicPortalLinks(subdomain) {
  const sub = String(subdomain || "").trim().toLowerCase();
  if (!sub) return [];

  return [
    {
      id: "patient",
      title: "Клиенты",
      url: buildClinicPortalUrl(sub, "/"),
    },
    {
      id: "staff",
      title: "Тренеры",
      url: buildClinicPortalUrl(sub, "/staff"),
    },
    {
      id: "admin",
      title: "Админка",
      url: buildClinicPortalUrl(sub, "/manage"),
    },
  ];
}
